import TokenManager from '../utils/tokenmanager';

const UserModel = Backbone.Model.extend({
  defaults: {
    'firstName': '',
    'lastName': '',
    'email': '',
    'password': 'Phillips456',
    'confirmPassword': 'Phillips456',
    'title': null,
    'sendNewsLetter': false,
    'primaryPhone': '',
    'userAddress': {
      countryID: 0,
      address1: '',
      address2: '',
      city: '',
      stateID: 0,
      province: '',
      zipCode: '',
      intlPostalCode: ''
    },
    'userId': '',
    'isActive': true,
    'showLocation': true
  },
  urlRoot: `${$('body').data('apidomain')}user`,
  initialize() {
    this.loggedIn = false;
    this.detailsFetched = false;
    this.creditCardsFetched = false;
    this.ready = false;
  },
  checkStorage() {
    if (TokenManager.isTokenSet()) {
      this.fetchUser();
    } else {
      this.ready = true;
      this.trigger('ready');
    }
  },
  getAuthToken() {
    return TokenManager.getSessionStorageToken();
  },
  parseAuthToken(token) {
    return `${token.token_type} ${token.access_token}`;
  },
  editUser(dataObj, el, userAddress) {
    const auth = this.parseAuthToken(this.getAuthToken());
    handleAjax(el);
    if (userAddress) {
      const bbData = this.get('userAddress').set(dataObj);
      this.save({
        'userAddress': bbData
      }, {
        headers: {
          'Authorization': auth
        },
        wait: true,
        success: (model, response) => {
          if (response.message === 'User information updated') {
            $(el).find('.response-msg')
              .text('You have successfully updated your details')
              .addClass('success');
            setTimeout(() => {
              $(el).find('.response-msg').removeClass('success');
            }, 5000);
          }
          this.trigger('addressUpdated', this);
        },
        error() {
          $(el).find('.response-msg')
            .text(`There was an error updating your details.
              Please try again later`)
            .addClass('error');
        }
      });
    } else {
      this.save(
        dataObj,
        {
          headers: {
            'Authorization': auth
          },
          wait: true,
          success: (model, response) => {
            if (response.message === 'User information updated') {
              if (this.get('firstName') !== this.previous('firstName')) {
                this.trigger('changedFirstName', this.get('firstName'));
              }
              $(el).find('.response-msg')
                .text('You have successfully changed your information')
                .addClass('success');
              setTimeout(() => {
                $(el).find('.response-msg').removeClass('success');
              }, 5000);
            }
          },
          error() {
            $(el).find('.response-msg')
              .text(`There was an error updating your information.
              Please try again later`)
              .addClass('error');
          }
        }
      );
    }
  },
  save: function(attrs) {
    const auth = this.getAuthToken(),
      q = $.Deferred();
    this.set(_.omit(attrs, 'userId'));
    Backbone.Model.prototype.save.call(this, this.attributes, {
      headers: {
        'Authorization': auth
      },
      success: (resp) => {
        q.resolve(resp);
      },
      error: (err, response) => {
        console.log('saveCB err: ', err, response);
        q.reject(err, response);
      }
    });
    return q.promise();
  },
  saveUser(dataNoPW) {
    let data = _.extend(dataNoPW, { 'password': 'Phillips456', 'confirmPassword': 'Phillips456' }),
      q = $.Deferred();

    $.post(`${$('body').data('apidomain')}universalaccount/register`, data).then(
      (resolve) => {
        this.saveCB(data).then((resolve2, resp, options) => {
          q.resolve(resolve);
        }, (reject2, resp, options) => {
          console.log('err ', reject2, resp, options);
          q.reject(reject2, resp);
        });
      }, (reject, resp) => {
        q.reject(reject, resp);
      });
    return q.promise();
  },
  loginBidMaster(clientKey) {
    const loginJson = {
        'Login': `BidsNewYork@phillips.com`,
        'Password': `B1dsMaster`
      },
      authHeader = `basic ${clientKey}`;
    $.ajax({
      type: 'POST',
      url: `${$('body').data('apidomain')}universalaccount/login`,
      headers: {
        'Authorization': authHeader
      },
      contentType: 'application/json',
      data: JSON.stringify(loginJson),
      success: (resp) => {
        TokenManager.setSessionStorageToken(`${resp.token_type} ${resp.access_token}`);
      },
      error: (resp) => {
        console.log('login failed: ', resp);
      }
    });
  },
  resetUser() {
    const data = _.omit(this.defaults, ['id', 'userId']);
    this.set(data);
  }
});

export default UserModel;
